<template>
  <div class="home">
    <div class="background-gradient"></div>
    <Hero />
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue'

export default {
  name: 'HomeView',
  components: {
    Hero
  }
}
</script>

<style lang="scss" scoped>
.home {
  min-height: 100vh;
  width: 100%;
  position: relative;
  overflow-x: hidden;
}

.background-gradient {
  position: fixed;
  inset: 0;
  z-index: 0;
  background: radial-gradient(125% 125% at 50% 90%, #fff 40%, #475569 100%);
  pointer-events: none;
}

.home::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 200%;
  height: 200%;
  pointer-events: none;
  z-index: 1;
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.03) 1px, transparent 1px),
    radial-gradient(circle at 40% 70%, rgba(255, 255, 255, 0.02) 1px, transparent 1px),
    radial-gradient(circle at 60% 20%, rgba(255, 255, 255, 0.015) 1px, transparent 1px),
    radial-gradient(circle at 80% 60%, rgba(255, 255, 255, 0.025) 1px, transparent 1px);
  background-size: 300px 300px;
  animation: particleFloat 40s linear infinite;
  opacity: 0.6;
}

@keyframes particleFloat {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(-300px, -300px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .home::before {
    animation: none;
  }
}
</style>
